import { RouteInfo } from './kycsidebar.metadata';

export const ROUTES: RouteInfo[] = [
  //   {
  //     path: '',
  //     title: 'Personal',
  //     icon: 'mdi mdi-dots-horizontal',
  //     class: 'nav-small-cap',
  //     extralink: true,
  //     submenu: []
  //   },
    {
      path: '/user/role',
      title: 'Select Role',
      icon: 'icon-Car-Wheel',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/user/kyc',
      title: 'Application Details',
      icon: 'icon-Data-Transfer',
      class: '',
      extralink: false,
      submenu: []
    },
  ];
